import { defHttp } from '/@/utils/http/axios';

enum Api {
    menuViewsApi = '/sys/view/',
    menuSelectedViewApi = '/sys/view/click',
    menuViewsSave = '/sys/view/addUserView',
    menuViewsUpdate = '/sys/view/editUserView',
    deleteViewApi = '/sys/view/deleteUserView/',
}

export const getMenuViews = (menuId) => {
    return defHttp.get({ url: Api.menuViewsApi + menuId },);
};

export const saveMenuSelectedView = (params) => {
    return defHttp.post({url: Api.menuSelectedViewApi, params}, {successMessageMode: 'none'})
}

// 保存菜单视图
export const saveMenuViewsApi = (params) => {
    return defHttp.post({url: Api.menuViewsSave, params}, {successMessageMode: 'none'}) 
}

// 更新菜单视图
export const updateMenuViewsApi = (params) => {
    return defHttp.post({url: Api.menuViewsUpdate, params}, {successMessageMode: 'none'})
}

// 删除菜单视图
export const deleteMenuView = (viewId) => {
  return defHttp.get({url: Api.deleteViewApi + viewId}, {successMessageMode: 'none'})
}
